import AlertDefinitionInfoPanel from 'thm/ui/common/alertDefinition/AlertDefinitionInfoPanel'
import ChildStache from 'thm/ui/common/alertDefinition/AlertDefinitionInvalidMoveInfoPanelTpl.stache'

/**
 * @class AlertDefinitionInvalidMoveInfoPanel
 *  Alert Definition "Invalid Move" Form.
 */
let AlertDefinitionInvalidMoveInfoPanel = AlertDefinitionInfoPanel.extend({
  id: 'alertDefinitionInvalidMoveInfoPanel',
  childTpl: ChildStache,
})
export default AlertDefinitionInvalidMoveInfoPanel
